export const commissionConfig: Record<string, string> = {
  'commcfg.tabRates': 'Tỷ lệ',
  'commcfg.tabTiers': 'Bậc thang',
  'commcfg.tabExchange': 'Tỷ giá',
  'commcfg.tabProjectGroups': 'Nhóm dự án',
  'commcfg.tabOwnership': 'Sở hữu',
  'commcfg.periodInherited': 'Kế thừa từ kỳ trước',
  'commcfg.readOnlyNotice': 'Bạn chỉ có quyền xem, không thể chỉnh sửa mục này',
  'commcfg.saved': 'Đã lưu',
  // Rates subtab
  'commcfg.deptRatesTitle': 'Tỷ lệ mặc định theo phòng ban',
  'commcfg.role.Product': 'Product',
  'commcfg.role.ASO': 'ASO',
  'commcfg.role.MO': 'MO',
  'commcfg.role.UA': 'UA',
  'commcfg.role.Dev': 'Dev',
  'commcfg.uaMoTiersNote': 'Dùng bậc thang hoa hồng (tab Bậc thang)',
  'commcfg.groupRatesTitle': 'Tỷ lệ theo nhóm (Publisher × Đối tác)',
  'commcfg.noGroups': 'Chưa có nhóm sản phẩm nào',
  'commcfg.noData': 'Chưa có dữ liệu',
  'commcfg.products': 'sản phẩm',
  'commcfg.expandAll': 'Mở tất cả',
  'commcfg.collapseAll': 'Thu gọn tất cả',
  // Tiers subtab
  'commcfg.uaTiers': 'Bậc thang UA',
  'commcfg.moTiers': 'Bậc thang MO',
  'commcfg.addTier': 'Thêm bậc',
  'commcfg.editTier': 'Sửa bậc',
  'commcfg.deleteTierConfirm': 'Xóa bậc thang này?',
  'commcfg.minProfitUsd': 'Lợi nhuận tối thiểu ($)',
  'commcfg.maxProfitUsd': 'Lợi nhuận tối đa ($)',
  'commcfg.maxProfitHint': 'Bỏ trống = không giới hạn',
  'commcfg.ratePercent': 'Tỷ lệ (%)',
  'commcfg.androidRatePercent': 'Android (%)',
  'commcfg.iosRatePercent': 'iOS (%)',
  'commcfg.noTiers': 'Chưa có bậc thang',
  'commcfg.invalidRate': 'Tỷ lệ không hợp lệ',
  // Exchange rates subtab
  'commcfg.exchangeRatesTitle': 'Tỷ giá VND/USD',
  'commcfg.azuraExchangeRatesTitle': 'Tỷ giá Azura (VND/USD)',
  'commcfg.editRate': 'Sửa tỷ giá',
  'commcfg.fillAllFields': 'Vui lòng nhập đầy đủ',
  'commcfg.month': 'Tháng',
  // Project groups subtab
  'commcfg.projectGroupsDesc': 'Doanh thu ròng AdMob và chi phí khác theo kỳ đang chọn',
  'commcfg.netRevenueByProduct': 'Net Revenue (Admob) theo sản phẩm',
  'commcfg.otherCostsByGroup': 'Chi phí khác theo nhóm dự án',
  'commcfg.current': 'Hiện tại',
  'commcfg.totalPh': 'Tổng…',
  'commcfg.dist': 'Chia',
  'commcfg.distTitle': 'Chia tổng cho các sản phẩm theo tỷ lệ gross profit',
  'commcfg.grossPct': 'Tỷ lệ gross profit trong nhóm',
  // Ownership subtab
  'commcfg.currentOwner': 'Chủ sở hữu hiện tại',
  'commcfg.fromDate': 'Từ ngày',
  'commcfg.addTransfer': 'Thêm chuyển nhượng',
  'commcfg.editOwnership': 'Sửa sở hữu',
  'commcfg.productName': 'Tên sản phẩm',
  'commcfg.transferCount': 'lần chuyển nhượng',
}
